import { FrameName } from "../config";
import TileEntity from "../TileEntity";

type FrameNames =
	| FrameName.SHALLOW_SEA_PEARL_HUNTER
	| FrameName.DEEP_SEA_PEARL_HUNTER;

class ShallowSeaPearlHunterBuildingTileEntity extends TileEntity {
	public static readonly frameName: FrameNames =
		FrameName.SHALLOW_SEA_PEARL_HUNTER;
}

export default ShallowSeaPearlHunterBuildingTileEntity;
